module.exports = __webpack_public_path__ + "static/media/mountain_biking_1600.a52d4f69.webp";